import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { BypassStatusService } from './bypass-status.service';
import { Icon } from '../../shared/icon/icon';

/**
 * Cartel global de "bypass de emergencia activo" (RF09): mientras el kill-switch que saltea
 * BCRA+peaje esté prendido, nadie está siendo evaluado — visible desde CUALQUIER pantalla del
 * panel, no solo Configuración o Alertas. Vive en el template raíz (app.html), fuera del Shell,
 * mismo criterio que backend-down-banner.
 */
@Component({
  selector: 'app-bypass-active-banner',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Icon],
  templateUrl: './bypass-active-banner.html',
  styleUrl: './bypass-active-banner.scss',
})
export class BypassActiveBanner {
  protected readonly status = inject(BypassStatusService);
}
